export default {
  methods: {
    close() {
      this.$emit('closeModal')
    },
  },
}
